import axios from "axios";
import Cookies from "js-cookie";
import saveAs from "file-saver";

const endPoint = process.env.REACT_APP_API_ENDPOINT;

/**
 * Downloads a file generated by the backend (e.g. the failed-records Excel).
 * The server builds it from every stored row, so it works for any number of failures.
 */
export const downloadServerFile = async (
  url: string,
  fallbackFileName: string
): Promise<void> => {
  const token = Cookies.get("accessToken");
  const response = await axios.get(`${endPoint}${url}`, {
    responseType: "blob",
    headers: token ? { Authorization: `bearer ${token}` } : undefined,
  });

  const disposition: string | undefined = response.headers?.["content-disposition"];
  const match = disposition ? /filename="?([^";]+)"?/i.exec(disposition) : null;
  saveAs(response.data as Blob, match?.[1] ?? fallbackFileName);
};

/** Error responses for blob requests arrive as a Blob; pull the message out of it. */
export const readBlobError = async (error: any): Promise<string> => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.message ?? "Download failed";
    } catch {
      return "Download failed";
    }
  }
  return error?.response?.data?.message ?? "Download failed";
};
